import { frontBase } from '@/shared/lib/passbook-utils';
import { Button } from '@/shared/ui/button';

interface OperatorRegisterInviteProps {
  idPassbook: string;
  shortUrl?: string;
  organizationName?: string;
  query: string;
  uniqueIdLabel: string;
  onRestart: () => void;
}

function displayUrl(url: string): string {
  return url.replace(/^https?:\/\//i, '').replace(/\/$/, '');
}

export function OperatorRegisterInvite({
  idPassbook,
  shortUrl,
  organizationName,
  query,
  uniqueIdLabel,
  onRestart,
}: OperatorRegisterInviteProps) {
  const inviteUrl = shortUrl?.trim() || `${frontBase()}/invite/${idPassbook}`;
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&margin=8&data=${encodeURIComponent(inviteUrl)}`;
  const shown = displayUrl(inviteUrl);

  return (
    <div
      id="operator-search-empty"
      className="relative flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border border-[hsl(var(--glass-border)/0.45)] bg-background/80"
      role="status"
    >
      <div className="h-2 w-full shrink-0 bg-primary" aria-hidden />

      <div className="flex min-h-0 flex-1 flex-col items-center overflow-y-auto px-4 py-5 text-center sm:px-6">
        <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-primary">
          Ainda não é do clube?
        </p>
        <h3 className="mt-2 max-w-md text-xl font-semibold tracking-tight sm:text-2xl">
          Cadastre-se e comece a ganhar
        </h3>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">
          Não encontramos <b>{query.trim()}</b> ({uniqueIdLabel.toLowerCase()} ou nome).
          {organizationName ? ` em ${organizationName},` : ''} acumule benefícios a cada compra,
          aponte a câmera no QR Code e cadastre-se.
        </p>

        <div className="mt-4 rounded-2xl bg-white p-2.5 shadow-glass ring-1 ring-black/5">
          <img
            src={qrSrc}
            alt={`QR Code de cadastro — ${shown}`}
            width={200}
            height={200}
            className="size-[160px] rounded-xl sm:size-[180px]"
          />
        </div>

        <a
          href={inviteUrl}
          target="_blank"
          rel="noreferrer"
          className="mt-3 break-all font-mono text-xs text-primary hover:underline sm:text-sm"
        >
          {shown}
        </a>

        <Button
          type="button"
          variant="secondary"
          className="mt-5 h-11 w-full max-w-xs shrink-0 rounded-2xl"
          onClick={onRestart}
        >
          Nova busca
        </Button>
      </div>
    </div>
  );
}
